import { Badge } from "@/components/ui/badge";

interface RecommendedBadgeProps {
  className?: string;
}

export const RecommendedBadge = ({ className = "" }: RecommendedBadgeProps) => {
  return (
    <Badge
      className={`bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] text-white border-0 px-2 py-0.5 text-xs ${className}`}
      variant="secondary"
    >
      Recommended
    </Badge>
  );
};
